import { cn } from '~/common/utils/styleUtil';
import { formatPrice } from '~/common/utils/numberUtil';
import { useTranslation } from 'react-i18next';

export interface CartPriceProps {
  price: number;
  className?: string;
  showCurrency?: boolean;
  size?: 'sm' | 'lg';
  showMinus?: boolean;
}

export function CartTotalPrice({
  price,
  showCurrency = false,
  size = 'lg',
  showMinus = false
}: Readonly<CartPriceProps>) {
  const { i18n } = useTranslation();
  const normalPriceFranken = Math.floor(price);
  const normalPriceRappen = Math.round((price - normalPriceFranken) * 100)
    .toString()
    .padStart(2, '0');

  return (
    <div>
      <div className={'flex justify-end'}>
        <div className={cn('flex w-fit py-0.5 pl-1.5 rounded pr-1.5')}>
          {showCurrency && (
            <div className={cn(size === 'lg' && 'text-base font-bold mr-2', size === 'sm' && 'text-xs font-bold mr-2')}>
              {'CHF'}
            </div>
          )}
          <div
            className={cn(size === 'lg' && 'text-3xl font-bold', size === 'sm' && 'text-base font-bold')}
            data-testid={`cart-total-price-text-1`}
          >
            {showMinus && <span>-</span>}
            <span>{formatPrice(normalPriceFranken, i18n.language, 0)}</span>
          </div>
          <div
            className={cn(size === 'lg' && 'text-base font-bold', size === 'sm' && 'pl-0.5 text-xs font-bold mt-0.5')}
            data-testid={`cart-total-price-text-2`}
          >
            {normalPriceRappen}
          </div>
        </div>
      </div>
    </div>
  );
}
